import React from 'react';
import { twMerge } from 'tailwind-merge';
interface ProgressBarProps {
  value: number;
  max?: number;
  className?: string;
  barClassName?: string;
  label?: string;
}
export function ProgressBar({
  value,
  max = 100,
  className,
  barClassName,
  label
}: ProgressBarProps) {
  const pct = Math.min(100, Math.max(0, value / (max || 1) * 100));
  return <div className={twMerge('h-1.5 w-full overflow-hidden rounded-full bg-ink-200', className)} role="progressbar" aria-valuemin={0} aria-valuemax={max} aria-valuenow={value} aria-label={label} data-id="element-367" data-mp="23l212pa03628">
      <div className={twMerge('h-full rounded-full bg-brand-600 transition-all duration-500', barClassName)} style={{
      width: `${pct}%`
    }} data-id="element-368" data-mp="2heba2ou1dpk8" />
    </div>;
}